// Layout + simulation constants for the LifeOS virtual headquarters

export const ROOM_W = 340;
export const ROOM_H = 250;
export const GAP_X = 90;
export const GAP_Y = 90;

export function roomPixel(dept) {
  const gx = dept.gx ?? 0;
  const gy = dept.gy ?? 0;
  return {
    x: gx * (ROOM_W + GAP_X),
    y: gy * (ROOM_H + GAP_Y),
  };
}

export function worldSize(departments) {
  let maxGx = 0;
  let maxGy = 0;
  departments.forEach((d) => {
    maxGx = Math.max(maxGx, d.gx ?? 0);
    maxGy = Math.max(maxGy, d.gy ?? 0);
  });
  return {
    width: (maxGx + 1) * (ROOM_W + GAP_X) + GAP_X,
    height: (maxGy + 1) * (ROOM_H + GAP_Y) + GAP_Y,
  };
}

// Workstation slot offsets inside a room content area
export const SLOTS = [
  { x: 72, y: 120 },
  { x: 200, y: 120 },
  { x: 72, y: 188 },
  { x: 200, y: 188 },
  { x: 136, y: 120 },
  { x: 136, y: 188 },
];

export const REST_SPOT = { x: 300, y: 210 };

export const STATUS_POOLS = {
  "Executive Office": ["Reviewing daily briefing...", "Approving budget...", "Setting priorities...", "Aligning departments...", "Signing off report..."],
  "Personal Assistant": ["Scanning inbox...", "Scheduling meeting...", "Drafting reply...", "Reviewing Gmail...", "Blocking calendar..."],
  "Marketing": ["Writing ad copy...", "Analyzing campaign...", "Designing post...", "Planning launch...", "Reviewing analytics..."],
  "Sales": ["Updating CRM...", "Qualifying lead...", "Sending proposal...", "Logging call...", "Chasing follow-up..."],
  "Finance": ["Reconciling invoices...", "Building forecast...", "Reviewing expenses...", "Closing the books...", "Auditing spend..."],
  "Operations": ["Optimizing workflow...", "Monitoring systems...", "Resolving ticket...", "Deploying update...", "Checking uptime..."],
  "Customer Support": ["Answering ticket...", "Escalating issue...", "Following up...", "Writing macro...", "Calming customer..."],
  "Research": ["Gathering sources...", "Summarizing paper...", "Compiling insights...", "Scraping data...", "Ranking findings..."],
  "Content Studio": ["Scripting video...", "Editing draft...", "Generating thumbnail...", "Reviewing cut...", "Polishing copy..."],
  "Meeting Room": ["Syncing with team...", "Presenting update...", "Taking notes...", "Debating strategy...", "Assigning actions..."],
};

export const GENERIC_STATUS = ["Processing queue...", "Researching...", "Preparing report...", "Cross-checking data...", "Optimizing output..."];

export function statusPool(deptName) {
  return STATUS_POOLS[deptName] || GENERIC_STATUS;
}

export const PERSONALITIES = ["Analytical", "Assertive", "Diligent", "Creative", "Hyper-Speed", "Calm"];
export const AUTONOMY_LEVELS = ["Supervised", "Semi-Autonomous", "Fully Autonomous"];

export const TOOLS = [
  "Gmail", "Google Calendar", "Slack", "Notion", "Salesforce CRM",
  "Stripe", "GitHub", "X / Twitter", "HubSpot", "Google Sheets",
];

export const ROLE_SUGGESTIONS = [
  "Chief of Staff", "Executive Assistant", "Email Manager", "Calendar Manager",
  "Sales Agent", "Marketing Manager", "Social Media Manager", "Content Creator",
  "Research Analyst", "Finance Controller", "Support Specialist", "Operations Lead",
];

export function initials(name) {
  if (!name) return "??";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export function timeAgo(iso) {
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86400)}d`;
}
